module.exports = __webpack_public_path__ + "static/media/logo-unichristus.b9b8178f.jpg";